import React from 'react';
import { StyledSideBar } from './SideBar.style';

const SideBar = (props) => {
  return <StyledSideBar {...props}>{props.children}</StyledSideBar>;
};

export default SideBar;
